import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

import { APP_BASENAME } from "app-constants";

export const defaultNS = "common";

i18n
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)

  // Fetch the translations using a HTTP backend
  // docs: https://github.com/i18next/i18next-http-backend
  .use(Backend)

  // detect user language
  // docs: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)

  // init i18next
  // docs for options: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: "en",
    backend: {
      loadPath: `${APP_BASENAME}/locales/{{lng}}/{{ns}}.json`,
      allowMultiLoading: true,
    },

    ns: [], // Remove the default ['translation']

    supportedLngs: ["en", "he"],
    nonExplicitSupportedLngs: false,
    defaultNS,
  });

export default i18n;
